var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menuItemMobileMenu" },
    [
      _vm.hasHeader
        ? _c("mobile-menu-section-header", {
            attrs: { label: _vm.headerLabel, labelId: _vm.headerLabelId },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }